import {combineReducers} from 'redux';
import * as Constant from './constants'

const loading = (state = false, action) => {
    switch (action.type) {
        case Constant.TRANSACTION_UPLOAD_FILE_CSV.SUCCESS:
        case Constant.TRANSACTION_UPLOAD_FILE_CSV.FAILED:
        case Constant.TRANSACTION_UPLOAD_FILE_CLEAR_STATE:
            return false;
        case Constant.TRANSACTION_UPLOAD_FILE_CSV.REQUEST:
            return true;
        default:
            return state;
    }
};

export default combineReducers({
    loading,
});